var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.069,
    height: 27.507,
    viewBox: "0 0 24.069 27.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bag-shopping-solid",
    d: "M6.017,6.017a6.017,6.017,0,0,1,12.034,0V8.6H21.49a2.579,2.579,0,0,1,2.579,2.579V22.349a5.159,5.159,0,0,1-5.158,5.158H5.158A5.158,5.158,0,0,1,0,22.349V11.175A2.579,2.579,0,0,1,2.579,8.6H6.017ZM8.6,8.6h6.877V6.017a3.438,3.438,0,0,0-6.877,0ZM7.307,13.753a1.289,1.289,0,1,0-1.289-1.289A1.286,1.286,0,0,0,7.307,13.753Zm9.456-2.579a1.289,1.289,0,1,0,1.289,1.289A1.286,1.286,0,0,0,16.762,11.175Z",
    fill: "#9c9a9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagShopping);
export default __webpack_public_path__ + "static/media/bag-shopping.d4053d36319d1b32434682abdd022685.svg";
export { ForwardRef as ReactComponent };